import { render } from "./LbrxLoginPad.vue?vue&type=template&id=fbccaece&scoped=true"
import script from "./LbrxLoginPad.vue?vue&type=script&lang=js"
export * from "./LbrxLoginPad.vue?vue&type=script&lang=js"

import "./LbrxLoginPad.vue?vue&type=style&index=0&id=fbccaece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbccaece"]])

export default __exports__